// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noteCount[data-v-e6c738a6]{font-size:26px;font-weight:700;color:#fff}.noteCount[data-v-e6c738a6]:hover{color:#fa8b59}", ""]);
// Exports
module.exports = exports;
